import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AltHeader from "../components/altheader"
import Contact from "../components/contact"

const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />
    <AltHeader 
    HeaderTitle="Contact Me!"
    HeaderDesc="Let's get started on an amazing project!"
    />
    <Contact />
  </Layout>
)

export default ContactPage
